export default __webpack_public_path__ + "cedc0aeb7f22969fc37869599ff217b4.svg";